<template>
  <div>
    <logged-in-header />
    <feedbacks-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import feedbacksPanel from "../components/feedbacks/FeedbacksPanel";

export default {
  components: {
    loggedInHeader,
    feedbacksPanel
  }
};
</script>
